export default "__VITE_ASSET__eed65a21__"